export const asThousand = (number, digits) => {
    let valToParse = '0'

    if (number) {
        if (typeof number !== 'string' || !number instanceof String) {
            valToParse = number.toString()
        } else {
            valToParse = number
        }
    }

    if (!valToParse.includes(',')) {
        let number = Number.parseFloat(valToParse)

        if (isNaN(number)) {
            return valToParse
        }

        return number.toLocaleString('en', {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        });
    }

    return valToParse
}

export default asThousand;
